import React from 'react';

import uuid from 'uuid';

import NotFound from '../NotFound';

import { StyledGeneralVision } from './style/StyledGeneralVision';

import DynamicComponent from '../../DynamicComponent';

const GeneralVision = ({ data, isLast, channel }) => (
	<StyledGeneralVision channel={channel}>
		<section>
			<h2>{data.title}</h2>
			<p>{data.content.text}</p>
		</section>

		{
			(data.charts.length > 0) ? (
				<div className="content-1200">
					{data.charts.map(chart => <DynamicComponent tag={chart.type} data={chart.data} typeChart="generalVision" channel={channel} key={uuid.v4()} />)}

					<div className="legend">
						<div className="topic-1">
							Cliques
						</div>

						<div className="topic-2">
							Impressões
						</div>
					</div>
				</div>
			) : (
				<section className="mt-4">
					<NotFound />
				</section>
				)
		}

		{!isLast ? <hr /> : null}
	</StyledGeneralVision>
);

export default GeneralVision;
